<template lang="pug">
.v-components.components(v-if="data" :id="data?.id")
	//-.components__title(v-if="(active?.text || active?.title) && !data.hideTitle") {{active.title || active.text}}
	.components__tags.tags(v-if="data.tabs" :class="[data.view ? 'tags--' + data.view : '']")
		.tags__items
			button.tags__item(v-for="tab in data.tabs" type="button" @click="active = tab" :class="{active: tab.id === active?.id}") {{tab.text}}
				img.tags__item-icon(v-if="tab.icon" :src="tab.icon")
	.components__body
		template(v-for="(tab, tabIndex) in data.tabs" :key="tabIndex")
			section.components__slot-wrap(:class="{'components__slot-wrap--shown': tab.slot === active.slot}")
				h2.components__title(v-if="(active?.text || active?.title) && !data.hideTitle" v-html="active.title || active.text" )
				slot(:name="tab.slot")
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null,
			active: null
		}
	},

	watch: {
		active(state) {
			if (state && state.remote && window.location.pathname.indexOf('/local/') < 0) {
				window.history.replaceState(null, null, state.remote);
			}
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
			this.active = this.data?.tabs?.find(tab => tab.active);
		}
	}
}

</script>